import type { LucideIcon } from "lucide-react"

interface ChartCardProps {
  icon: LucideIcon
  title: string
  subtitle?: string
  controls?: React.ReactNode
  footer?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function ChartCard({
  icon: Icon,
  title,
  subtitle,
  controls,
  footer,
  children,
  className = "",
}: ChartCardProps) {
  return (
    <div
      className={`bg-white/70 backdrop-blur-sm border border-slate-200/50 rounded-lg shadow-sm h-full flex flex-col ${className}`}
    >
      {/* Header */}
      <div className="px-4 py-3 border-b border-slate-200/50 bg-gradient-to-r from-slate-50/50 to-white/50 flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[#dbeafe] rounded-xl flex items-center justify-center shadow-sm">
              <Icon className="w-4.5 h-4.5" style={{ color: "#1e40af" }} />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-slate-900 leading-tight">
                {title}
              </h3>
              {subtitle && (
                <p className="text-xs text-slate-500 leading-tight">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {controls && (
            <div className="flex items-center gap-2">{controls}</div>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0 p-4">{children}</div>

      {/* Footer */}
      {footer && (
        <div className="px-4 py-2.5 border-t border-slate-200/50 bg-slate-50/50 flex-shrink-0">
          {footer}
        </div>
      )}
    </div>
  )
}
